import { n as linkDetectionOptions } from "./link-detection-gp7k5p_k.mjs";
import { find } from "linkifyjs";
//#region src/split-text-by-links.ts
/** Splits a plain text into text segments and http(s):// or www. link segments, `start` being each segment's offset in `text`. */
function splitTextByLinks(text) {
	if (text.length === 0) return [];
	if (text.length > 1e4) return [{
		type: "text",
		text,
		start: 0
	}];
	const segments = [];
	let cursor = 0;
	for (const link of find(text, linkDetectionOptions)) {
		if (link.start > cursor) segments.push({
			type: "text",
			text: text.slice(cursor, link.start),
			start: cursor
		});
		segments.push({
			type: "link",
			text: link.value,
			href: link.href,
			start: link.start
		});
		cursor = link.end;
	}
	if (cursor < text.length) segments.push({
		type: "text",
		text: text.slice(cursor),
		start: cursor
	});
	return segments;
}
//#endregion
export { splitTextByLinks };

//# sourceMappingURL=index.mjs.map